import { jsxs, jsx } from 'react/jsx-runtime';
import '../icons/ActivityIcon.js';
import '../icons/ArrowDownIcon.js';
import '../icons/ArrowDownRightCircleIcon.js';
import '../icons/ArrowLeftAlignIcon.js';
import '../icons/ArrowLeftIcon.js';
import '../icons/ArrowRightAlignIcon.js';
import '../icons/ArrowRightIcon.js';
import '../icons/ArrowUpIcon.js';
import '../icons/ArrowUpRightCircleIcon.js';
import '../icons/ArrowsAngleExpandIcon.js';
import '../icons/BankIcon.js';
import '../icons/CheckIcon.js';
import '../icons/ChevronDownIcon.js';
import '../icons/ChevronRightIcon.js';
import '../icons/ChevronUpIcon.js';
import '../icons/CopyIcon.js';
import '../icons/CrossIcon.js';
import '../icons/DaiIcon.js';
import '../icons/DangerIcon.js';
import '../icons/DownSortIcon.js';
import '../icons/ExclamationTriangleIcon.js';
import '../icons/ExpandKpiIcon.js';
import '../icons/EyeIcon.js';
import '../icons/EyeSlashIcon.js';
import '../icons/Grid1x2Icon.js';
import InfoCircleIcon from '../icons/InfoCircleIcon.js';
import '../icons/ListIcon.js';
import '../icons/LockIcon.js';
import '../icons/MediumIcon.js';
import '../icons/MoonIcon.js';
import '../icons/PiggyBankIcon.js';
import '../icons/QuestionMarkCircleIcon.js';
import '../icons/ShieldIcon.js';
import '../icons/SunIcon.js';
import '../icons/UpSortIcon.js';
import '../icons/XIcon.js';
import '../../client-components/ThemeProvider.js';
import 'react';
import '../../client-components/Tabs/Tabs.module.scss.js';
import 'classnames';
import '../Table/components/HeaderCell.module.scss.js';
import '../layout/Flex/Flex.js';
import '../layout/Row/Row.module.scss.js';
import '../layout/Stack/Stack.js';
import '../layout/Box/Box.js';
import '../Table/Table.module.scss.js';
import '../Table/components/TableRow.module.scss.js';
import '../Table/components/Pagination.module.scss.js';
import '../Text/Text.js';
import '../Table/components/TableCell/TableCell.module.scss.js';
import '../Card/Card.module.scss.js';
import '../List/List.module.scss.js';
import '../ErrorBox/ErrorBox.module.scss.js';
import '../InfoBox/InfoBox.module.scss.js';
import '../KpiCard/KpiCard.module.scss.js';
import '../TrendValue/TrendValue.module.scss.js';
import '../Modal/Modal.module.scss.js';
import '../Badge/Badge.module.scss.js';
import 'luxon';
import '../HeatmapActivity/HeatmapActivity.module.scss.js';
import Tooltip, { TooltipTrigger, TooltipContent } from '../../client-components/Tooltip/Tooltip.js';
import '../Switch/Switch.module.scss.js';
import '@blockanalitica/ui';
import '../Select/Select.module.scss.js';
import '../pictograms/EthPictogram.js';
import '../pictograms/EtherScanPictogram.js';
import '../pictograms/DebankPictogram.js';
import '../pictograms/ZapperPictogram.js';
import '../pictograms/DaiPictogram.js';
import 'react-loading-skeleton';
import '../../client-components/ThemeModeSelector/ThemeModeSelector.module.scss.js';
import '../../client-components/ExpandableCard/ExpandableCard.module.scss.js';
import '../../client-components/ExpandableKpiCard/ExpandableKpiCard.module.scss.js';
import '../../client-components/CopyButton/CopyButton.module.scss.js';
import 'ethereum-blockies-base64';
import '../../client-components/WalletAddress/WalletAddress.module.scss.js';
import '../../client-components/filters/TextSearchFilter/TextSearchFilter.module.scss.js';
import '../../client-components/sidebars/FixedSidebar/components/MobileTopNavBar/MobileTopNavbar.module.scss.js';
import '../../client-components/sidebars/FixedSidebar/components/Sidebar/Sidebar.module.scss.js';
import '../../client-components/sidebars/FixedSidebar/FixedSidebar.module.scss.js';
import '../../client-components/sidebars/CollapsableSidebar/CollapsableSidebar.module.scss.js';
import '../../client-components/FormattedCurrency/FormattedCurrency.js';
import '../../client-components/FormattedPercentage/FormattedPercentage.js';
import '../../client-components/CurrencyValue/CurrencyValue.module.scss.js';
import '../../client-components/PercentageValue/PercentageValue.module.scss.js';
import '../../client-components/DisplaySwitch/DisplaySwitch.module.scss.js';
import 'lodash';
import '../../client-components/charts/ChartJS.js';
import '../../client-components/charts/components/ChartKpis/ChartKpis.module.scss.js';
import '../../client-components/charts/components/ChartSingleValueIndicator/ChartSingleValueIndicator.module.scss.js';
import '../../client-components/charts/BarChart/BarChart.module.scss.js';
import '../../client-components/charts/LineChart/LineChart.module.scss.js';
import '../../client-components/charts/AreaChart/AreaChart.module.scss.js';
import 'randomcolor';
import 'd3';
import '../../client-components/Checkbox/Checkbox.module.scss.js';

function InfoTooltip({ text, size = 14, options }) {
    return (jsxs(Tooltip, { ...options, children: [jsx(TooltipTrigger, { children: jsx(InfoCircleIcon, { size: size }) }), jsx(TooltipContent, { children: text })] }));
}

export { InfoTooltip as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5mb1Rvb2x0aXAuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3NlcnZlci1jb21wb25lbnRzL0luZm9Ub29sdGlwL0luZm9Ub29sdGlwLnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBJbmZvQ2lyY2xlSWNvbiB9IGZyb20gJy4uL2ljb25zJztcblxuaW1wb3J0IHtcbiAgVG9vbHRpcFRyaWdnZXIsXG4gIFRvb2x0aXAsXG4gIFRvb2x0aXBDb250ZW50XG59IGZyb20gJy4uLy4uL2NsaWVudC1jb21wb25lbnRzJztcbmltcG9ydCB7IFRvb2x0aXBPcHRpb25zIH0gZnJvbSAnLi4vLi4vY2xpZW50LWNvbXBvbmVudHMvVG9vbHRpcC9Ub29sdGlwJztcblxudHlwZSBJbmZvVG9vbHRpcFByb3BzID0ge1xuICB0ZXh0OiBzdHJpbmc7XG4gIHNpemU/OiBudW1iZXI7XG4gIG9wdGlvbnM/OiBUb29sdGlwT3B0aW9ucztcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIEluZm9Ub29sdGlwKHtcbiAgdGV4dCxcbiAgc2l6ZSA9IDE0LFxuICBvcHRpb25zXG59OiBJbmZvVG9vbHRpcFByb3BzKSB7XG4gIHJldHVybiAoXG4gICAgPFRvb2x0aXAgey4uLm9wdGlvbnN9PlxuICAgICAgPFRvb2x0aXBUcmlnZ2VyPlxuICAgICAgICA8SW5mb0NpcmNsZUljb24gc2l6ZT17c2l6ZX0gLz5cbiAgICAgIDwvVG9vbHRpcFRyaWdnZXI+XG5cbiAgICAgIDxUb29sdGlwQ29udGVudD57dGV4dH08L1Rvb2x0aXBDb250ZW50PlxuICAgIDwvVG9vbHRpcD5cbiAgKTtcbn1cbiJdLCJuYW1lcyI6WyJfanN4cyIsIl9qc3giXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBZXdCLFNBQUEsV0FBVyxDQUFDLEVBQ2xDLElBQUksRUFDSixJQUFJLEdBQUcsRUFBRSxFQUNULE9BQU8sRUFDVSxFQUFBO0lBQ2pCLFFBQ0VBLElBQUMsQ0FBQSxPQUFPLEVBQUssRUFBQSxHQUFBLE9BQU8sYUFDbEJDLEdBQUMsQ0FBQSxjQUFjLEVBQ2IsRUFBQSxRQUFBLEVBQUFBLEdBQUEsQ0FBQyxjQUFjLEVBQUEsRUFBQyxJQUFJLEVBQUUsSUFBSSxFQUFJLENBQUEsRUFBQSxDQUNmLEVBRWpCQSxHQUFBLENBQUMsY0FBYyxFQUFBLEVBQUEsUUFBQSxFQUFFLElBQUksRUFBQSxDQUFrQixDQUMvQixFQUFBLENBQUEsRUFDVjtBQUNKOzs7OyJ9
